import dynamic from 'next/dynamic'
import { customVariants } from './tile-variants-custom'
import SkeletonCard from '../../skeleton/card/skeleton-card'

const Skeleton = () => <SkeletonCard orientation="horizontal" />

// DON'T USE VARIABLE FOR DYNAMIC OPTIONS, CAUSE Did not expect server HTML to contain a <div> in <div>
/* const dynamicOptions = {
	loading: Skeleton,
} */

const TileWishListBase = dynamic(() => import('./base'), {
	loading: Skeleton,
})
const TileWishListCompact = dynamic(() => import('./compact'), {
	loading: Skeleton,
})
const TileWishListExpanded = dynamic(() => import('./expanded'), {
	loading: Skeleton,
})

export const variants = {
	base: TileWishListBase,
	compact: TileWishListCompact,
	expanded: TileWishListExpanded,
	...customVariants,
}
